import Handlebars from 'handlebars/dist/handlebars.runtime';
        const templateFunction = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<nav aria-label=\"Products list Pagination\">\n  <h2 class=\"sr-only\">Pagination</h2>\n  <ol class=\"pagination__list\" data-component=\"pagination\"></ol>\n</nav>";
},"useData":true});
        export default templateFunction;